import { reportClientError } from '../services/api';

// Код ошибки: E-<время в base36>-<случайные 3 символа>. По нему ошибку можно найти в журнале событий (client_error).
export function errorCode() {
  const t = Date.now().toString(36).toUpperCase().slice(-6);
  const r = Math.random().toString(36).toUpperCase().slice(2, 5);
  return `E-${t}-${r}`;
}

// Отправить ошибку на бэкенд. Никогда не бросает.
export function report(code, error, extra = {}) {
  try {
    reportClientError({
      code,
      message: String(error?.message || error || 'unknown').slice(0, 1000),
      stack: String(error?.stack || '').slice(0, 4000),
      url: window.location.href,
      user_agent: navigator.userAgent,
      ...extra,
    }).catch(() => {});
  } catch {
    /* отчёт не должен ломать страницу */
  }
}
